export default [
    {
        weight: 50,
        input: true,
        type: "textfield",
        key: "variableName",
        label: "Variable Name",
        placeholder: "e.g., myVariable or myForm.myVariable",
        tooltip: "The query parameter name to read from the URL (e.g., 'myVariable'). " +
            "If the query parameter is present in the URL when the form opens, it will automatically populate this field.",
        validate: {
            required: false
        }
    }
];
